import React from 'react';

// Base skeleton animation class
const shimmer = "animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]";

// Generic skeleton box
export const SkeletonBox = ({ className = "" }) => (
  <div className={`${shimmer} rounded ${className}`} />
);

// Project card skeleton
export const ProjectCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-lg overflow-hidden">
    <SkeletonBox className="h-48 sm:h-56 w-full rounded-none" />
    <div className="p-6">
      <SkeletonBox className="h-6 w-3/4 mb-2" />
      <SkeletonBox className="h-4 w-1/2 mb-4" />
      <SkeletonBox className="h-4 w-1/3" />
    </div>
  </div>
);

// Blog post card skeleton
export const BlogCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-lg overflow-hidden">
    <SkeletonBox className="h-48 w-full rounded-none" />
    <div className="p-6">
      <SkeletonBox className="h-4 w-1/4 mb-3" />
      <SkeletonBox className="h-6 w-full mb-2" />
      <SkeletonBox className="h-6 w-3/4 mb-4" />
      <SkeletonBox className="h-4 w-full mb-2" />
      <SkeletonBox className="h-4 w-2/3" />
    </div>
  </div>
);

// Team member skeleton
export const TeamMemberSkeleton = () => (
  <div className="text-center">
    <SkeletonBox className="w-32 h-32 mx-auto rounded-full mb-4" />
    <SkeletonBox className="h-5 w-24 mx-auto mb-2" />
    <SkeletonBox className="h-4 w-20 mx-auto" />
  </div>
);

// Text block skeleton
export const TextBlockSkeleton = ({ lines = 3 }) => (
  <div className="space-y-2">
    {Array.from({ length: lines }).map((_, i) => (
      <SkeletonBox 
        key={i} 
        className={`h-4 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} 
      />
    ))}
  </div>
);

// Partner logo skeleton
export const PartnerLogoSkeleton = () => (
  <SkeletonBox className="h-12 w-24 rounded" />
);

// Projects grid skeleton
export const ProjectsGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    {Array.from({ length: count }).map((_, i) => (
      <ProjectCardSkeleton key={i} />
    ))}
  </div>
);

// Blog grid skeleton
export const BlogGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    {Array.from({ length: count }).map((_, i) => (
      <BlogCardSkeleton key={i} />
    ))}
  </div>
);

// Full page loading skeleton
export const PageLoadingSkeleton = () => (
  <div className="min-h-screen bg-gray-50 py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <SkeletonBox className="h-10 w-64 mx-auto mb-4" />
        <SkeletonBox className="h-6 w-96 mx-auto" />
      </div>
      <ProjectsGridSkeleton count={6} />
    </div>
  </div>
);

export default {
  SkeletonBox,
  ProjectCardSkeleton,
  BlogCardSkeleton,
  TeamMemberSkeleton,
  TextBlockSkeleton,
  PartnerLogoSkeleton,
  ProjectsGridSkeleton,
  BlogGridSkeleton,
  PageLoadingSkeleton
};
